import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import SignUpForm from '../signupforms/SignUpForm';

interface InterestFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  title?: string;
  subtitle?: string;
}

export default function InterestFormModal({ 
  isOpen, 
  onClose, 
  className = '',
  title = 'Express Your Interest',
  subtitle = "We'll notify you about upcoming classes and special offers."
}: InterestFormModalProps) {
  
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent scrolling when modal is open
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Close when clicking outside the modal content
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) onClose();
  };
  
  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
      onClick={handleBackdropClick}
    >
      <div 
        className={`bg-white rounded-xl max-w-md w-full p-6 max-h-[90vh] overflow-y-auto ${className}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-start mb-4">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <p className="text-gray-600 mt-1">{subtitle}</p>
          </div>
          <button 
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Close"
          >
            <X className="w-6 h-6 text-gray-500" />
          </button>
        </div>
        
        <SignUpForm onSuccess={onClose} />
      </div>
    </div>
  );
} 